<template>
  <KTTable
    title="Cargos"
    subtitle="Lista de cargos"
    :fields="fields"
    :endpoint="endpoint"
    :delete="DELETE_CARGO"
    @edit="editItem($event)"
  ></KTTable>
</template>

<script>
import KTTable from "@/view/content/Table.vue";
import { DELETE_CARGO } from "@/core/services/store/cargos.module";

export default {
  name: "dashboard",
  components: { KTTable },
  data() {
    return {
      DELETE_CARGO,
      endpoint: "dic_cargos",
      fields: [
        {
          key: "id_cargo",
          label: "Código Cargo",
          sortable: true
        },
        {
          key: "descripcion",
          label: "Literal del Cargo",
          sortable: true
        },
        {
          key: "id_area",
          label: "Código Área Cargo",
          sortable: true
        },
        {
          key: "actions",
          label: ""
        }
      ]
    };
  },
  methods: {
    editItem(item) {
      this.$router.push(`${this.$route.path}/${item.id_cargo}`);
    }
  }
};
</script>
